import { render, staticRenderFns } from "./featuredParent.vue?vue&type=template&id=0e1c0a59&scoped=true&"
import script from "./featuredParent.vue?vue&type=script&lang=js&"
export * from "./featuredParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c0a59",
  null
  
)

export default component.exports